<!-- ==============================
  File Name: UserProfile.vue
  Description: User Profile page
  -------------------------------
=============================== -->

<template>
  <div id="app-user-profile">
    <div class="vx-col w-full" v-if="User && User.Id">
      <vx-card code-toggler>
        <div class="vx-row">
          <div class="vx-col sm:w-1/2 w-full mb-2">
            <label>Email: {{User.Email}}</label>
          </div>
        </div>
        <div class="vx-row" v-if="User.Role == 'Partner Admin' || User.Role == 'Partner Staff'">
          <div class="vx-col sm:w-1/2 w-full mb-2">
            <label>Partner: {{PartnerName}}</label>
          </div>
        </div>
        <div class="vx-row">
          <div class="vx-col sm:w-1/2 w-full mb-2">
            <vs-input v-validate="'required'" class="w-full" label-placeholder="Name*" name="Name" v-model="User.Name"/>
            <span class="text-danger text-sm" v-show="errors.has('Name') && isSaveForm">{{ errors.first('Name') }}.</span>
          </div>
          <div class="vx-col sm:w-1/2 w-full mb-2">
            <vs-input v-validate="'required|numeric'" class="w-full" label-placeholder="Phone*" name="Phone" v-model="User.Phone"/>
            <span class="text-danger text-sm" v-show="errors.has('Phone') && isSaveForm">{{ errors.first('Phone') }}.</span>
          </div>
        </div>
        <div class="vx-row">
          <div class="vx-col sm:w-1/2 w-full mb-6">
            <vs-textarea label="Profile" class="mb-2 font-sm" name="Profile" v-model="User.Profile" />
          </div>
        </div>
        <div class="vx-row">
          <div class="vx-col w-full">
            <vs-button class="mr-3 mb-2" @click.prevent="saveUser">Save</vs-button>
          </div>
        </div>
        <a class="pointer" @click.prevent="resetPassword">Send Reset Password Link.</a>
      </vx-card>
    </div>
  </div>
</template>

<script>
import moduleUserManagement from "@/store/user-management/moduleUserManagement.js";
import UserService from "@/services/UserService";
import UtilService from "@/services/UtilService";
import PartnerService from "@/services/PartnerService";
import vSelect from 'vue-select'
import  '@/assets/css/main.css'
import firebase from "firebase";

export default {
  components: {
     'v-select': vSelect,
  },
  data() {
     return {
      userInfo: {},
      partners: [],
      emailExistMessage: '',
      isPartner:false,
      User: {
        Id: '',
        Email: '',
        Name: '',
        Phone: '',
        Role: '',
        Profile: '',
        PartnerId: '',
        Timezone: this.userInfo.Timezone,
        Status: 'Active',
        IsDeleted: 0,
        CreatedBy: '',
        Company: '',
        ModifiedBy: ''
      },
      activeTab: 0,
      isSaveForm: false,
      PartnerName: '',
    };
  },
  computed: {},
  methods: {
    saveUser(){
      let userObj = {...this.User}
      this.isSaveForm = true;
      if(this.userInfo){
        this.$validator.validateAll().then(result => {
          if(result) {
            if(this.User.Id){ 
              this.User["ModifiedBy"] = this.User['Id'];
              UserService.updateUser(this.User.Id, this.User)
                .then(() => {
                  UserService.updateFirebaseUser(this.User, (err, data) => {
                      if(!err){
                        UtilService.notifySuccessAlert(this.$vs, 'Profile updated successfully.');
                        localStorage.setItem("userInfo", JSON.stringify(this.User));
                      } else {
                        UtilService.notifyErrorAlert(this.$vs, err.message);
                      }
                  });
                })
                .catch(e => {
                  console.log(e);
                });
            }
          }
        })
      }
    },
    resetPassword() {
      this.$vs.dialog({
        type: 'confirm',
        color: 'danger',
        title: 'Confirmation',
        text: `Are you sure to reset password?`,
        accept: this.sendResetPasswordLink,
        acceptText: 'Yes'
      })
    },
    sendResetPasswordLink(){
      if(this.User && this.User.Email){
        firebase
          .auth()
          .sendPasswordResetEmail(this.User.Email)
          .then(() => {
            UtilService.notifySuccessAlert(this.$vs, 'Reset password link sent successfully.');
          }).catch((error) => {
            if(error){
              UtilService.notifyErrorAlert(this.$vs, error.message);
            }
          })
      }
    },
    getPartnerName(PartnerId){
      PartnerService.getById(PartnerId).on("value",partner => {
        let data = partner.val();
        this.PartnerName = data.CompanyName;
      })
    }
  },
  created() {
    const userInfo = JSON.parse(localStorage.getItem("userInfo"));
    this.User = {...userInfo};
    this.getPartnerName(this.User.PartnerId);
  }
};
</script>

<style lang="scss">
#avatar-col {
  width: 10rem;
}

#page-user-view {
  table {
    td {
      vertical-align: top;
      min-width: 140px;
      padding-bottom: 0.8rem;
      word-break: break-all;
    }

    &:not(.permissions-table) {
      td {
        @media screen and (max-width: 370px) {
          display: block;
        }
      }
    }
  }
}
.pointer{
  cursor: pointer;
}

@media screen and (min-width: 1201px) and (max-width: 1211px),
  only screen and (min-width: 636px) and (max-width: 991px) {
  #account-info-col-1 {
    width: calc(100% - 12rem) !important;
  }
}
</style>
